"use client"

import {useEffect, useState} from 'react';
import {placeCategoriesRequest} from "@/utils/api/Place";
import {PlaceCategories} from "@/types/Places";

const usePlaceCategoriesData = () => {
  const [data, setData] = useState<PlaceCategories | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      const fetched = await placeCategoriesRequest()
      if (fetched) {
        setData(fetched);
      }
    }
    if (!data) {
      fetchData();
    }
  }, [data]);

  return data;
};

export default usePlaceCategoriesData;
